import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    verified: false,
    uid: '',
    cart: [],
    orders: {},
  },
  getters: {
    cart: state => state.cart,
  },
  mutations: {
    changeUserAuthStatus(state, { auth, verified, uid }) {
      state.isAuthenticated = auth;
      state.verified = verified;
      state.uid = uid;
    },
    addToCart(state, item) {
      state.cart.push(item);
    },
    setCart(state, cart) {
      state.cart = cart;
    },
    removeFromCartWithIndex(state, index) {
      state.cart.splice(index, 1);
    },
    clearCart(state) {
      state.cart = [];
    },
    addToOrders(state, payload) {
      state.orders[payload.id] = payload;
    },
  },
  actions: {},
});
